export default __webpack_public_path__ + "static/media/security.787b6bae.png";